export default __webpack_public_path__ + "static/media/vehicle-desktop.f2cd7319.svg";